export type MasterDetailSlots = {
  /** The list/menu pane: wide always, narrow only while nothing is picked. */
  showList: boolean;
  /** The narrow-only back row above the detail: narrow with a pick. */
  showBack: boolean;
  /** The detail pane: wide always, narrow with a pick. */
  showDetail: boolean;
};

// The three-slot boolean shape behind every master-detail surface fixed for
// MX-8 (CatalogBrowse, SettingsScreen, WorkoutsScreen): wide shows list and
// detail side by side; narrow shows exactly one, picked by `hasSelection`,
// with a back row above the detail. Pulled out once three call sites had it
// byte-for-byte identical (consolidation, prompt.md §Consolidamento): no
// JSX here, only the booleans a caller's own slots read to decide what to
// render, so it stays reusable across the different chrome each surface
// wraps its slots in.
//
// The reconciliation reason this shape matters lives with the callers: it
// keeps a stateful subtree (a form being edited, a session being logged) at
// the SAME position across a resize, one null-when-absent slot at a time,
// instead of the two structurally different trees that used to tear it down.
export function useMasterDetailSlots(
  wide: boolean,
  hasSelection: boolean,
): MasterDetailSlots {
  return {
    showList: wide || !hasSelection,
    showBack: !wide && hasSelection,
    showDetail: wide || hasSelection,
  };
}
